import EditorJS from "@editorjs/editorjs";
import editorParser from "editorjs-html";
import Header from "@editorjs/header";
import List from "@editorjs/list";

const EditorJSHook = {
  mounted(this: any) {
    const inputHTML = <any>document.getElementById(this.el.dataset.inputId);
    const parser = editorParser();

    const editor = new EditorJS({
      holder: this.el.id,
      minHeight: 0,
      tools: {
        header: Header,
        list: {
          class: <any>List,
          inlineToolbar: true,
        },
      },
      data: JSON.parse("{}"),
      onReady: () => {
        if (inputHTML.value) editor.blocks.renderFromHTML(inputHTML.value);

        // Stop `input` and `change` events of inputs within EditorJS from propagating
        // to prevent triggering form's `phx-change`
        this.el.addEventListener("input", (event: any) =>
          event.stopPropagation(),
        );
        this.el.addEventListener("change", (event: any) =>
          event.stopPropagation(),
        );
      },
      onChange: () => {
        editor.save().then((outputData) => {
          const htmlData = parser.parse(outputData);

          inputHTML.value = htmlData;
        });
      },
    });
  },
};

export default EditorJSHook;
